<template>

<div>

  <div class="text-block">

    <div class="contact-title">
      <Common :text="title"/>
    </div>

    <SmallCommon :text="text"/>

  </div>

  <div class="button-block">
    <div>
      <a :href="href" target="_blank">{{ button }}</a>
    </div>
  </div>

</div>

</template>

<script>
import Common from '../../general/texts/Common.vue'
import SmallCommon from '../../general/texts/SmallCommon.vue'

export default {
  name: 'S04Contact',
  props: {
    title: String,
    text: String,
    button: String,
    href: String
  },
  components: {
    Common,
    SmallCommon
  }
}
</script>

<style lang="scss" scoped>
.text-block {
  width: 60%;
  display: inline-block;
  margin-right: 10%;

  .contact-title {
    text-transform: uppercase;
  }
}

.button-block {
  width: 25%;
  display: inline-block;
  text-align: center;
  vertical-align: super;

  div {
    font-size: 20px;
    text-align: center;
    line-height: 1em;
    text-transform: uppercase;
    text-decoration: none;
    border: solid 2px #ffffff;
    border-radius: 27px;
    background-color: transparent;
    padding: 15px 20px;

    &:hover {
      background-color: rgba(255, 255, 255, 0.2);
    }
  }
}

@media (max-width: 1000px), (max-device-width: 1000px) {
  .text-block {
    width: 100%;
    display: block;

    .contact-title {
      margin-top: 70px;
    }
  }

  .button-block {
    min-width: 200px;
    max-width: 100%;
    display: block;
  }
}
</style>
